import usePwaPrompt from '@/shared/hooks/usePwaPrompt.js';
import IOSPwaPrompt from '@/shared/components/pwa/IOSPwaPrompt.jsx';
import DesktopPwaPrompt from '@/shared/components/pwa/DesktopPwaPrompt.jsx';

const PwaPromptContainer = () => {
  const { showPrompt, platform, dismissPrompt } = usePwaPrompt();

  if (!showPrompt) return null;

  if (platform === 'ios') {
    return (
      <IOSPwaPrompt showPrompt={showPrompt} dismissPrompt={dismissPrompt} />
    );
  }

  return (
    <DesktopPwaPrompt showPrompt={showPrompt} dismissPrompt={dismissPrompt} />
  );
};

export default PwaPromptContainer;
